// extracted by mini-css-extract-plugin
export default {"button":"weglot-switcher_button__7mlCP","option":"weglot-switcher_option__4s2B3","list":"weglot-switcher_list__eFNuF","container":"weglot-switcher_container__P3+mh"};